export const parseSakTitleToHTML = (sakTitle) => {
  const regex = new RegExp('\\|(.*?)\\|', 'g')
  return sakTitle ? sakTitle.replace(regex, '<b>$1</b>') : ''
}
